import { render } from "./receiptsComponent.vue?vue&type=template&id=2b5f1051&scoped=true"
import script from "./receiptsComponent.vue?vue&type=script&lang=js"
export * from "./receiptsComponent.vue?vue&type=script&lang=js"

import "./receiptsComponent.vue?vue&type=style&index=0&id=2b5f1051&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5f1051"]])

export default __exports__